import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  // },
  {
    path: "/",
    name: "Forgas",
    component: (resolve) => require(["@/views/forgas.vue"], resolve),
  },
  {
    path: "/about",
    name: "About",
    component: (resolve) => require(["@/views/about.vue"], resolve),
  },
  {
    path: "/hydrogenCompressor",
    name: "HydrogenCompressor",
    component: (resolve) => require(["@/views/hydrogenCompressor.vue"], resolve),
  },
  {
    path: "/cngCompressor",
    name: "CNGCompressor",
    component: (resolve) => require(["@/views/cngCompressor.vue"], resolve),
  },
  {
    path: "/details",
    name: "Details",
    component: (resolve) => require(["@/views/details.vue"], resolve),
  }
];

const router = new VueRouter({
  routes,
});

export default router;
